<template>
	<div class="login">
		<img class="login-banner" src="@/assets/tl-logo.png" alt="teamleader" />
		<v-sheet rounded class="login-container">
			<h1 class="login-heading">Sign in to your account</h1>
			<form class="login-form">
				<v-row no-gutters>
					<v-col cols="12">
						<v-text-field
							v-model="user.username"
							@keyup.enter="submitLogin"
							label="Username"
							outlined
							dense
							hide-details="auto"
						></v-text-field>
					</v-col>
					<v-col cols="12">
						<v-text-field
							v-model="user.password"
							label="Password"
							:append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
							:type="showPassword ? 'text' : 'password'"
							@click:append="showPassword = !showPassword"
							@keyup.enter="submitLogin"
							outlined
							dense
							hide-details="auto"
						></v-text-field>
						<p v-show="passwordError" class="login-failed">Invalid Password!</p>
					</v-col>
				</v-row>
				<v-btn color="primary" class="login-form-btn" @click="submitLogin">Login</v-btn>
				<v-btn color="primary" class="login-form-btn" text>Forgot your password?</v-btn>
			</form>
		</v-sheet>
	</div>
</template>

<script>
import { hasRole, hasAnyRole, WellKnownRoles } from "@/models/User";

export default {
	name: "Login",
	data: () => ({
		user: {
			username: "",
			password: "",
		},
		showPassword: false,
		passwordError: false,
	}),
	methods: {
		async submitLogin() {
			this.$store
				.dispatch("login", this.user)
				.then(() => {
					this.$store.dispatch("retrievesystemCategories", this);
					this.$systemCategories.load(this);
					this.navigate();
				})
				.catch((error) => {
					if (error.response.status == 401 || error.response.status == 400) {
						this.passwordError = true;
					} else {
						console.log(error);
					}
				});
		},
		navigate() {
			// Check if user is a shipper-only user (no admin privileges)
			const user = this.$store.getters.userInfo;
			const isShipperOnly = user &&
				hasRole(user, WellKnownRoles.SHIPPER) &&
				!hasAnyRole(user, [WellKnownRoles.ADMIN, WellKnownRoles.SUPER_ADMIN]);

			// Shipper-only users go directly to shipper dashboard
			if (isShipperOnly) {
				this.$router.push("/shipper");
				return;
			}

			// Other users use redirect URI or home
			var to = this.$store.getters.redirectUri ? this.$store.getters.redirectUri : "/";
			this.$router.push(to);
		},
	},
};
</script>

<style lang="scss" scoped>
.login {
	position: relative;
	width: 100%;
	height: calc(100vh - 24px);
	background-color: $color-gray-light-2;

	&-banner {
		position: absolute;
		display: block;
		top: 6rem;
		left: 50%;
		transform: translateX(-50%);
		width: 80vh;
		height: auto;
		max-width: 750px;
	}

	&-container {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		padding: 3rem;
		width: 45rem;
		box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
	}

	&-heading {
		font-size: 2.5rem;
		font-weight: normal;
		margin-bottom: 5rem;
	}

	&-form {
		display: flex;
		flex-flow: column wrap;
		align-items: center;

		.col {
			margin-bottom: 1.5rem;
		}

		& > &-btn {
			font-size: 1.4rem;
			font-weight: normal;
			text-transform: initial;
			margin: 1rem 0;
			width: 18rem;

			&:nth-of-type(2) {
				font-size: 1.2rem;
			}
		}
	}

	&-failed {
		position: absolute;
		color: $color-red;
		font-size: 1.2rem;
	}
}
::v-deep {
	.v-label {
		font-size: 1.4rem;
	}
	.v-input--selection-controls {
		margin-top: 0;
		padding-bottom: 4px;
	}
}
</style>
